// @flow

import type { AppType } from "shared/types/AppType"

export default ({
  asyncComponentResolve: () => import("apps/news/News"),
  orderPrio: 95,
  iconType: "exception",
  name: "news",
  mergeable: true,
  subApps: [
    {
      name: "feed",
      requirePermission: ["news:read", "news:driver-read"]
    },
    {
      name: "publish",
      requirePermission: "news:create"
    }
  ]
}: AppType)
